import { Environment } from '../lib/models';

export const dev: Environment = {
  production: false,
  PAYMENT_API_URL: 'https://dev-api-payment.seech.com',
  PAYMENT_STRIPE_PUBLIC_KEY:
    'pk_test_51SAfwCII5hq1gt82EyrhpIaJrqVwkczMrQV5C4My85ttvjEkNOWkNbjyf1GIHvRTA2MumOCfe8ivlWWqqWu1ZudA005n8Q5KKX',
  AUTH_API_URL: 'https://dev-api-auth-seech.azurewebsites.net/api/',
  AUTH_WEB_URL: 'https://dev-auth.seech.com',
  ACCOUNT_WEB_URL: 'https://dev-account.seech.com',
  PAYMENT_WEB_URL: 'https://dev-payment.seech.com',
  GLOBAL_CDN_URL: 'https://dev-cdn.seech.com/seech',
  SHARED_CDN_URL: 'https://dev-cdn.seech.com/shared',
};
